import { Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { getTooltipDateRange } from "../utils";

const CustomText = ({ children, ...props }) => (
  <Typography
    {...props}
    sx={{ fontSize: "10px", lineHeight: "140%", fontWeight: 500, ...props.sx }}
  >
    {children}
  </Typography>
);

export default function CustomChartTooltip({ chartContext, period, hours }) {
  if (!chartContext) {
    return null;
  }

  const { chart, tooltip } = chartContext;

  if (!tooltip?.dataPoints || tooltip.dataPoints.length === 0) {
    return null;
  }

  const dataIndex = tooltip.dataPoints[0]?.dataIndex;
  const dataSets = chart.config._config.data.datasets;

  if (dataIndex === undefined || dataIndex === null || !dataSets || dataSets.length === 0) {
    return null;
  }

  const dateRange = getTooltipDateRange(hours?.scheduled, dataIndex, period);

  return (
    <Stack px={4} py={3} gap={3}>
      <CustomText>{dateRange}</CustomText>
      <Divider />
      {dataSets.map((dataset, index) => {
        const dataValue = dataset.data[dataIndex];
        return (
          <Stack key={index} direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" gap={1} alignItems="center">
              <span
                style={{
                  backgroundColor: dataset.backgroundColor,
                  width: "8px",
                  height: "8px",
                  borderRadius: "4px",
                }}
              />
              <CustomText>{dataset.label}</CustomText>
            </Stack>
            <CustomText>{dataValue !== undefined ? dataValue : "N/A"}</CustomText>
          </Stack>
        );
      })}
    </Stack>
  );
}
